export default "__VITE_ASSET__54d0afcc__"